export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/offices')
    },

    async add(form) {
        return await $axios.post('/offices', form)
    },

    async fetchById(id) {
        return await $axios.get(`/offices/${id}`)
    },

    async update(id, form) {
        return await $axios.put(`/offices/${id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/offices/${id}`)
    },
})
